import React, { useState, useEffect } from "react";
import BookingService from "../../../../../../services/BookingService";
import { toast } from "react-toastify";

import MbeBookSlotSlider from "../../../../../../components/Molecules/BookSlot/MbeBookSlotSlider";
import Select from "../../../../../../components/Atomes/Select/Select";
import { dataRegionsArray } from "../../../../../../utils/RegionsUtils";

const ResBookingPart = ({}) => {
  const [bookings, setBookings] = useState([]);
  const [page, setPage] = useState(1);
  const [firstLoad, setFirstLoad] = useState(true);

  const selectValues = dataRegionsArray;
  const selectOptions = dataRegionsArray;
  const [region, setRegion] = useState("");
  const filterByRegion = (event) => {
    if (event.target.value === "Toutes les agences") {
      setRegion("");
      setBookings([]);
      setPage(1);
    } else {
      setRegion(event.target.value);
      setBookings([]);
      setPage(1);
    }
  };

  useEffect(() => {
    const getBookings = async () => {
      const request = await BookingService.getBookings({
        region: region,
        page: 1,
      });
      if (request.request.status === 200) {
        setBookings(request.data.shifts);
      } else {
        toast.error(
          "Une erreur est survenue lors de la récupération de la liste des Bookings"
        );
      }
    };
    getBookings();
  }, [region]);

  const loadMoreBookings = async () => {
    if (firstLoad) {
      setFirstLoad(false);
      return;
    }

    if (page >= 5) return;
    const nextPage = page + 2;
    setPage(nextPage);

    let request = await BookingService.getBookings({
      region: region,
      page: nextPage,
    });

    if (request.request.status === 200) {
      setBookings((prev) => [...prev, ...request.data.shifts]);
    }
  };

  return (
    <>
      <Select
        defaultValue={"Toutes les agences"}
        styleSelect={"select-custom-secondary"}
        data={selectOptions}
        value={selectValues}
        onChange={filterByRegion}
      />
      <MbeBookSlotSlider
        bookings={bookings}
        bookingSlotCreator={false}
        onReachEnd={loadMoreBookings}
      />
    </>
  );
};

export default ResBookingPart;
